export enum EstateSelectTab {
  Owner = "owner",
  Tenant = "tenant",
}
